var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FloatingPanel',[_c('div',{staticClass:"canvas-blocks-sky-price-BlockPanel"},[_c('SwitchInput',{attrs:{"label":"Toon disclaimer?","options":_vm.options,"options-property":"show_disclaimer","items":[
                { value: '1', label: 'Ja'},
                { value: '0', label: 'Nee'} ],"defaultValue":"1","open":true}}),_vm._v(" "),_c('CommonInputs',{attrs:{"options":_vm.options}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }